// How long a Copilot dashboard query stays cached after its last subscriber
// unmounts. Together with the "CopilotDashboard" tag this lets revisits and
// modals reuse data instantly; the dashboard's Refresh button (and its timed
// auto-refresh) invalidates the tag to force everything to refetch.
export const COPILOT_CACHE_SECONDS = 300;
